import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/delete/${number | ':id'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/delete/:id`;

export const URL = (id: number): RouteDefinition => `${baseRoute}/delete/${id}`;
